const ROOT_KEY = "bm_reports";

export const queryKeys = {
  supplyUtilization: (params: Record<string, any>) => [ROOT_KEY, "supplyUtilization", { params }],
  supplyStats: (params: Record<string, any>) => [ROOT_KEY, "supplyStats", { params }]
};
